












































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import axios from "axios";
import { Plotly } from 'vue-plotly';

import _, { forEach } from "lodash";


axios.defaults.baseURL = process.env.BASE_URL;

@Component({
    computed: mapGetters(["getUser"]),
    components: { Plotly }
})


export default class ScoresComponent extends Vue {

    @Prop()
    DeSIACTIVqId: any;

    @Prop()
    handleJobs: any;

    @Prop()
    jobs: any;

    @Prop()
    ascendance_social: any;

    @Prop()
    ouverture_social: any;

    @Prop()
    ascendance_real: any;

    @Prop()
    ouverture_real: any;

    @Prop()
    var_phrase: any;

    getUser: any;
    referrer: any = {};
    baseurl = process.env.BASE_URL;

    scores: any = {};

    activities_R: Array<number> = [];
    activities_Theta: Array<string> = [];

    secteurs_R: Array<number> = [];
    secteurs_Theta: Array<string> = [];

    sortedSecteurs: any = {};
    sortedActivities: any = {};

    autonomies: any = [];
    durations: any = [];
    handicap: any = [];
    secteurs_List: any[] = [];
    families_List: any[] = [];

    currentHandicap: any[] = [];
    currentPCD: any[] = [];
    currentAutonomy: any[] = [];
    currentDuration: any[] = [];
    currentSecteur: any[] = [];
    currentSitension: any = false;
    currentFamily: any[] = [];
    new_data: any = [];


    duration_data: any = [];
    autonomy_data: any = [];
    secteur_data: any = [];
    pcd_data: any = [];
    handicap_data: any = [];
    siTension_data: any = [];
    family_data: any = [];
    webAddresses: any = [];
    othersWebAddresses: any = [];
    InitialRefMetier: any = [];


    clickedMetier = "";
    new_data_updated = false;
    NoNewDataSelected = true;

    PCD: Array<string> = [];

    profils: any = [];

    get handicap_opts() {
        return this.handicap.map(e => e.handicap);
    }


    get autonomies_opts() {

        return this.autonomies.map(e => e.autonomie);
    }

    get durations_opts() {

        return this.durations.map(e => e.duree_etudes)

    }


    get googleExist() {
        return this.webAddresses.filter(e => e.description.toLowerCase() == 'google').length > 0;
    }

    get mapsExist() {
        return this.webAddresses.filter(e => e.description.toLowerCase() == 'maps').length > 0;
    }


    get othersExist() {
        return this.webAddresses.filter(e => (e.description.toLowerCase() != 'maps' && e.description.toLowerCase() != 'google')).length > 0;
    }

    othersSearchClicked(metier) {
        this.$bvModal.show("modal-searchMetier");
        this.clickedMetier = metier;
        this.othersWebAddresses = this.webAddresses.filter(e => (e.description.toLowerCase() != 'maps' && e.description.toLowerCase() != 'google'));
    }


    googleSearch(metier) {
        const address = this.webAddresses.filter(e => e.description.toLowerCase() == 'google')[0];
        window.open(address.webAdderess + metier);
    }

    googleMapsSearch(metier) {
        const address = this.webAddresses.filter(e => e.description.toLowerCase() == 'maps')[0];
        window.open(address.webAdderess + metier);
    }

    othersSearch(metier) {
        const address = this.webAddresses.filter(e => (e.description.toLowerCase() != 'maps' && e.description.toLowerCase() != 'google'))
        window.open(metier.webAdderess + encodeURIComponent(this.clickedMetier));
    }


    //////////////////////////////////////////////////////////////////////////////////

    @Watch("currentDuration")
    durationChanged() {
        this.durationSelected();
    }

    durationSelected() {
        const data_var: any = [];
        if (this.currentDuration.length > 0) {
            this.jobs.forEach(job => {
                this.currentDuration.forEach(duration => {
                    if (job.duree_etudes.toLowerCase() == duration.toLowerCase()) {
                        data_var.push(job);
                    }
                })
            });

            this.duration_data = data_var;
        } else {
            this.duration_data = this.jobs;
        }

        this.new_data_updated = true;
    }

    //////////////////////////////////////////////////////////////////////////////////

    @Watch("currentAutonomy")
    autonomyChanged() {
        this.autonomySelected();
    }

    autonomySelected() {

        if (this.currentAutonomy.length > 0) {
            const data_var: any = [];
            this.jobs.forEach(job => {
                this.currentAutonomy.forEach(autonomy => {
                    if (job.autonomie == autonomy) {
                        data_var.push(job);
                    }
                })
            });
            this.autonomy_data = data_var;
        } else {
            this.autonomy_data = this.jobs;
        }

        this.new_data_updated = true;
    }

    //////////////////////////////////////////////////////////////////////////////////

    @Watch("currentSecteur")
    secteurChanged() {
        this.secteurSelected();

    }

    secteurSelected() {

        if (this.currentSecteur.length > 0) {
            const data_var: any = [];
            this.jobs.forEach(job => {
                this.currentSecteur.forEach(sectItem => {

                    if (job.secteurs == sectItem.secteur) {
                        data_var.push(job);
                    }
                });
            });
            this.secteur_data = data_var;
        } else {
            this.secteur_data = this.jobs;
        }
        this.new_data_updated = true;
    }

    @Watch("secteur_data")
    secteurDataChanged() {

        const familiesListVar = this.secteur_data.map(j => j.famille_metier)
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.secteur_data.length == this.jobs.length) {
            this.currentFamily = []
        }
        else {
            if (this.currentFamily.length == 0) {
                this.currentFamily = familiesListVar;
            }
            else {
                const notSelected = _.difference(this.families_List, this.currentFamily);
                this.currentFamily = _.difference(familiesListVar, notSelected);
            }

        }

        this.families_List = familiesListVar;
    }

    ///////////////////////////////////////////////////////////////////////////////////
    @Watch("currentFamily")
    familyChanged() {
        this.familySelected();
    }

    familySelected() {

        if (this.currentFamily.length > 0) {
            const data_var: any = [];
            this.jobs.forEach(job => {
                this.currentFamily.forEach(famItem => {

                    if (job.famille_metier == famItem) {
                        data_var.push(job);
                    }
                });
            });
            this.family_data = data_var;
        } else {
            this.family_data = this.jobs;
        }
        this.new_data_updated = true;

    }

    //////////////////////////////////////////////////////////////////////////////////

    @Watch("currentPCD")
    pcdChanged() {
        this.pcdSelected();
    }

    pcdSelected() {

        const data_var: any = [];
        if (this.currentPCD.length > 0) {
            this.jobs.forEach(job => {
                this.currentPCD.forEach(pcdItem => {
                    if (job.pcd == pcdItem) {
                        data_var.push(job);
                    }
                })
            });
            this.pcd_data = data_var;
        } else {
            this.pcd_data = this.jobs;
        }

        this.new_data_updated = true;
    }

    //////////////////////////////////////////////////////////////////////////////////

    @Watch("currentHandicap")
    handicapChanged() {
        this.handicapSelected();
    }

    handicapSelected() {

        const data_var: any = [];
        if (this.currentHandicap.length > 0) {
            this.jobs.forEach(job => {
                this.currentHandicap.forEach(handicapItem => {
                    if (job.handicap_1 == handicapItem || job.handicap_2 == handicapItem || job.handicap_3 == handicapItem || job.handicap_4 == handicapItem || job.handicap_5 == handicapItem) {
                        data_var.push(job);
                    }
                })
            });
            this.handicap_data = data_var;
        } else {
            this.handicap_data = this.jobs;
        }

        this.new_data_updated = true;
    }

    ///////////////////////////////////////////////////////////////////////////////////

    @Watch("currentSitension")
    SitensionChanged() {
        this.SitensionSelected();
    }

    SitensionSelected() {

        const data_var: any = [];

        this.jobs.forEach(job => {
            if (this.currentSitension == true && job.si_tension != null) {
                data_var.push(job);
            } else if (this.currentSitension == false && job.si_tension == null) {
                data_var.push(job);
            }
        });

        this.siTension_data = data_var;
        this.new_data_updated = true;

    }


    ///////////////////////////////////////////////////////////////////////////////////

    @Watch("new_data_updated")
    newDataChanged() {

        if (this.new_data_updated) {
            this.new_data = [];

            if (this.currentDuration.length > 0 || this.currentAutonomy.length > 0 || this.currentPCD.length > 0 || this.currentSecteur.length > 0 || this.currentFamily.length > 0) {
                this.new_data = _.intersection(this.duration_data,
                    this.autonomy_data,
                    this.secteur_data,
                    this.pcd_data,
                    this.family_data
                );
            }
            //filtres complementaires: ajouter leurs resultats aux premieres selections
            if (this.currentHandicap.length > 0 && this.currentSitension == true) {
                this.new_data = _.union(this.new_data, _.union(this.handicap_data, this.siTension_data));
            }
            else {
                if (this.currentHandicap.length > 0) {
                    this.new_data = _.union(this.new_data, this.handicap_data);
                }

                if (this.currentSitension == true) {
                    this.new_data = _.union(this.new_data, this.siTension_data);
                }
            }

            if (this.currentDuration.length == 0 && this.currentAutonomy.length == 0 && this.currentPCD.length == 0 && this.currentSecteur.length == 0 && this.currentHandicap.length == 0 && this.currentSitension == false && this.currentFamily.length == 0) {
                this.new_data = this.jobs;
            }

            this.new_data = _.sortBy(this.new_data, [e => 1 - e['percent']]);
            if (this.new_data.length) {
                //this.new_data = this.siTension_data;
                this.NoNewDataSelected = false;
            }
            else {
                this.NoNewDataSelected = true;
            }

            if (this.new_data.length > 50) {
                this.new_data = this.new_data.slice(0, 50);
            }

            this.$store
                .dispatch("setmetierList", this.new_data.map(e => e.id))
                .then(() => {
                })
                .catch();

            this.new_data_updated = false;
        }

    }

    levelResponse = "";
    ageResponse = 0;
    experienceResponse = 0;

    async fetchData() {
        try {
            const ansScores = await axios.get("/api/depouillateDeSIACTIV", { params: { id: this.DeSIACTIVqId } });
            this.scores = ansScores.data;

            await this.$store.dispatch("setDeSIActivQuestionnaireResponded", true);

            // Activités
            for (const key in this.scores.activities_values) {
                const act = this.scores.activities_values[key];
                if (act.percent > 0) {
                    this.activities_R.push(act.percent * 100);
                    this.activities_Theta.push(act.activity);
                }
            }

            // Trier les secteurs (percent DESC, secteur ASC)
            this.sortedSecteurs = _.orderBy(
                _.values(this.scores.secteurs_values)   // convertir en tableau
                    .filter(s => s.percent > 0),        // ignorer 0%
                ['percent', 'secteur'],                 // champs de tri
                ['desc', 'asc']                         // ordre
            );

            // ---- Règle du graphe : TOP3 >= 50% ----
            // 1. Trier 
            const secteurs = _.orderBy(
                _.values(this.scores.secteurs_values).filter(s => s.percent > 0),
                ['percent', 'secteur'],
                ['desc', 'asc']
            );

            // 2. Si moins de 2 secteurs, pas besoin d’algorithme
            if (secteurs.length === 0) {
                this.secteurs_R = [];
                this.secteurs_Theta = [];
                return;
            }

            // Déterminer les valeurs de TOP1, TOP2, TOP3
            const top1 = secteurs[0].percent;
            const top2 = secteurs[1] ? secteurs[1].percent : null;
            const top3 = secteurs[2] ? secteurs[2].percent : null;

            // 3. Construire la sélection finale
            let selection = [];

            // Ajouter toute la série TOP1
            selection.push(
                ...secteurs.filter(s => s.percent === top1)
            );

            // Ajouter toute la série TOP2 s’il existe
            if (top2 !== null) {
                selection.push(
                    ...secteurs.filter(s => s.percent === top2)
                );
            }

            // 4. Ajouter TOP3 si ≥ 75%
            if (top3 !== null && top3 >= 0.75) {
                selection.push(
                    ...secteurs.filter(s => s.percent === top3)
                );
            }

            // 5. Éviter les doublons
            selection = _.uniq(selection);

            // 6. Limiter à 7 si nécessaire (mais après avoir fini les séries)
            if (selection.length > 7) {
                selection = selection.slice(0, 7);
            }

            // 7. Sortie Plotly
            this.secteurs_R = selection.map(s => s.percent * 100);
            this.secteurs_Theta = selection.map(s => s.secteur);

            // Secteurs
            /*    for (const key in this.scores.secteurs_values) {
                    const sec = this.scores.secteurs_values[key];
                    if (sec.percent > 0) {
                        this.secteurs_R.push(sec.percent * 100);
                        this.secteurs_Theta.push(sec.secteur);
                    }
                }
    
                // ✅ Limiter à 7 secteurs pour le graphe
                if (this.secteurs_R.length > 7) {
                    this.secteurs_R = this.secteurs_R.slice(0, 7);
                    this.secteurs_Theta = this.secteurs_Theta.slice(0, 7);
                }



            //this.sortedSecteurs = _.sortBy(this.scores.secteurs_values, [e => 1 - e['percent'], e => e['secteur']]);
            this.sortedSecteurs = _.orderBy(
                _.values(this.scores.secteurs_values) // convertit l'objet en tableau
                    .filter(s => s.percent > 0),      // supprime percent = 0
                ['percent', 'secteur'],                // champs pour trier
                ['desc', 'asc']                        // desc pour percent, asc pour secteur
            );*/
            this.sortedActivities = _.sortBy(this.scores.activities_values, [e => 1 - e['percent'], e => e['activity']]);

            // Initial Secteurs
            const ansDeSIACTIV = await axios.get("/api/get_DeSIACTIV_data", { params: { view: 'DeSIACTIVsecteurs' } });
            const initialSecteurs: any = [];
            for (let i = 0; i < Math.min(3, this.sortedSecteurs.length); i++) {

				const secteurItem = this.sortedSecteurs[i];
				if (!secteurItem) continue;

				// TOP 1 et TOP 2 toujours ajoutés
				if (i === 0 || i === 1) {
					const found = ansDeSIACTIV.data.find(e => e.secteur === secteurItem.secteur);
					if (found) {
						initialSecteurs.push(found._id);
					}
				}

				// TOP 3 seulement si >= 75%
				else if (i === 2 && secteurItem.percent >= 0.75) {
					const found = ansDeSIACTIV.data.find(e => e.secteur === secteurItem.secteur);
					if (found) {
						initialSecteurs.push(found._id);
					}
				}
			}

            // Secteurs List et familles
            const ansSecteurs = await axios.get("/api/get_DeSIACTIV_data", { params: { view: 'secteurs' } });
            this.secteurs_List.push(...ansSecteurs.data);
            this.families_List = this.jobs.map(j => j.famille_metier).filter((v, i, a) => a.indexOf(v) === i);

            // Secteurs Matching
            const ansMatching = await axios.get("/api/get_DeSIACTIV_data", { params: { view: 'secteursMatching' } });
            initialSecteurs.forEach(e => {
                this.InitialRefMetier = _.union(this.InitialRefMetier, ansMatching.data.filter(a => a.desiACTIV === e).map(b => b.refMetiers)[0]);
            });
            this.InitialRefMetier.forEach(i => {
                this.currentSecteur.push(this.secteurs_List.filter(e => i === e._id)[0]);
            });

            if (this.handleJobs) {
                this.new_data = _.sortBy(this.jobs, [e => 1 - e['percent']]);
                if (this.new_data.length > 50) this.new_data = this.new_data.slice(0, 50);

                this.duration_data = this.jobs;
                this.autonomy_data = this.jobs;
                this.secteur_data = this.jobs;
                this.pcd_data = this.jobs;
                this.handicap_data = this.jobs;
                this.siTension_data = this.jobs;
                this.family_data = this.jobs;

                const ansPCD = await axios.get("/api/PCDFilters");
                this.PCD = ansPCD.data.map(profil => profil.pcdName);

                const ansVariables = await axios.get("/api/JobMatchingVariableData");
                this.durations = ansVariables.data.durations;
                this.autonomies = ansVariables.data.autonomies;

                const ansHandicap = await axios.get("/api/get_DeSIACTIV_data", { params: { view: 'atypismes_et_handicaps' } });
                this.handicap = ansHandicap.data;

                const ansWeb = await axios.get("/api/webAddressMetier");
                this.webAddresses = ansWeb.data;

                const ansAnswers = await axios.get("/api/DeSIACTIVanswers", { params: { id: this.DeSIACTIVqId } });
                if (ansAnswers.data.selectAll) {
                    this.currentDuration = this.durations.map(e => e.duree_etudes);
                    this.currentAutonomy = this.autonomies.map(e => e.autonomie);
                } else {
                    ansAnswers.data.currentDurationFilters.forEach(d => {
                        this.currentDuration.push(this.durations.filter(e => e._id === d).map(e => e.duree_etudes)[0]);
                    });
                    ansAnswers.data.currentAutonomyFilters.forEach(d => {
                        this.currentAutonomy.push(this.autonomies.filter(e => e._id === d).map(e => e.autonomie)[0]);
                    });

                    for (let i = 0; i < 3; i++) {
                        if (this.sortedActivities[i]["activity"] === "Réaliser soi-même" && this.sortedActivities[i]["percent"] >= 0.75) {
                            this.currentAutonomy.push(this.autonomies.filter(e => e._id === "641987d460a539c0384dd051").map(e => e.autonomie)[0]);
                            break;
                        }
                    }
                }
            }

        } catch (err) {
            console.log(err)
            if (err.response?.status === 404) {
                this.$toast.info(err.response.data);
            } else {
                this.$toast.error("Oops, le chargement a échoué !");
            }
        }
    }


    getJobInfos(i) {

        let str = 'Métier : ' + this.new_data[i]['metier'] + '\n' +
            'Secteur : ' + this.new_data[i]['secteurs'] +
            ' ( Famille : ' + this.new_data[i]['famille_metier'] + ' )\n' +
            "Durée d'études :  " + this.new_data[i]['duree_etudes'] +
            ', Autonomie : ' + this.new_data[i]['autonomie'] + '\n' +
            'PCD : ' + this.new_data[i]['pcd'];

        if (this.new_data[i]['si_tension']) {
            str += '\nCaractéristiques : Métier en tension';
        }

        if (this.new_data[i]['handicap']) {
            str += '\nHandicaps : ' + this.new_data[i]['handicap'];
        }

        return str;
    }

    getProfil(asc, ouv, type) {

        asc = asc * 100;
        ouv = ouv * 100;

        axios.get("/api/socailRealProfils")
            .then(ans => {

                let str = '';
                this.profils = ans.data;
                this.profils.forEach(profil => {

                    if (profil.ascendance.name == "Asc < ") {

                        if (profil.ouverture.name == "Ouv < ") {
                            if (asc < profil.ascendance.value && ouv < profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                        else if (profil.ouverture.name == "Ouv >= ") {
                            if (asc < profil.ascendance.value && ouv >= profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                        if (profil.ouverture.name == "Ouv > ") {
                            if (asc < profil.ascendance.value && ouv > profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                    }
                    else if (profil.ascendance.name == "Asc >= ") {
                        if (profil.ouverture.name == "Ouv < ") {
                            if (asc >= profil.ascendance.value && ouv < profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                        else if (profil.ouverture.name == "Ouv >= ") {
                            if (asc >= profil.ascendance.value && ouv >= profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                        if (profil.ouverture.name == "Ouv > ") {
                            if (asc >= profil.ascendance.value && ouv > profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                    }
                    else if (profil.ascendance.name == "Asc > ") {
                        if (profil.ouverture.name == "Ouv < ") {
                            if (asc > profil.ascendance.value && ouv < profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                        else if (profil.ouverture.name == "Ouv >= ") {
                            if (asc > profil.ascendance.value && ouv >= profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                        if (profil.ouverture.name == "Ouv > ") {
                            if (asc > profil.ascendance.value && ouv > profil.ouverture.value) {
                                str = profil.profil;
                            }
                        }
                    }
                })
                if (type == 'social') {
                    this.socialProfil = str;
                }
                else {
                    this.realProfil = str;
                }
            })
    }

    socialProfil = '';
    realProfil = '';

    getInitialPCDFilter() {

        this.getProfil(this.ascendance_social, this.ouverture_social, 'social');
        this.getProfil(this.ascendance_real, this.ouverture_real, 'real');
        var interval = setInterval(() => {
            if (this.socialProfil != "" && this.realProfil != "") {

                clearInterval(interval);

                const soc = this.profils.filter(e => e.profil == this.socialProfil).map(e => e.id)[0];
                const real = this.profils.filter(e => e.profil == this.realProfil).map(e => e.id)[0];

                axios.get("/api/PCDFilters")
                    .then(ans => {
                        const arr: Array<string> = [];
                        ans.data.filter(profil => {
                            if (profil.filterCombination.filter(e => e.realProfil == real && e.socialProfil == soc).length) {
                                arr.push(profil.pcdName);
                            }
                        });
                        this.currentPCD = arr;
                    })

            }
        }, 100);

    }


    mounted() {

        this.fetchData();
        this.getInitialPCDFilter();


    }

}
